module.exports = __webpack_public_path__ + "img/Registered.9305a096.jpg";